import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  wrapper: {
    maxWidth: '100%',
    marginTop: 16,
    display: 'flex',
    gap: 20,
    alignItems: 'flex-start',
    overflow: 'hidden'
  },
  title: {
    paddingBottom: 16
  },
  tableContainer: {
    display: 'flex',
    width: '100%',
    maxWidth: '100%',
    overflow: 'auto',
    boxSizing: ' border-box'
  }
}))
